import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";

const Forbidden = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate(routes.home);
    }, 3000);
  }, []);
  return (
    <div className="coming-soon">
      <h1
        style={{
          textAlign: "center",
          fontSize: "30px",
          fontWeight: "bold",
          color: "#fff",
        }}
      >
        Page non autorisée !
      </h1>
    </div>
  );
};

export default Forbidden;
